<template>
  <div class="bottom-bar">
    <div class="title-container p-3">
      <div class="texts">
        <h4 class="text name" :style="textOverflow">{{ data.title }}</h4>
        <span class="text amount"
          >{{ data.totalContents }} {{ $t('main.groupers.collections.designs') }}</span
        >
      </div>
      <div v-if="showSeeMore">
        <div class="see-more">
          {{ $t('main.groupers.collections.button') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    showSeeMore: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    textOverflow() {
      return `text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 140px;`;
    }
  }
};
</script>

<style lang="scss" scoped>
.bottom-bar {
  min-height: 50px;
  position: relative;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
.title-container {
  color: black;
  font-weight: 400;
  transition: 0.4s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.texts {
  display: flex;
  flex-direction: column;
}
.text.name {
  font-size: 1em;
  font-weight: 500;
  margin-bottom: 5px;
}
.text.amount {
  font-size: 10px;
  color: #575757;
}
.see-more {
  font-size: 11px;
  padding: 3px 13px;
  color: $strongGray;
  border-color: $strongGray;
  background-color: #fff;
  border-radius: 23px;
  border: 1px solid;
  font-weight: 400;
  white-space: nowrap;
}
.see-more:hover {
  color: #fff;
  background-color: #3e80f0;
  border-color: #fff;
}
#app.design .see-more:hover {
  background-color: #20b9b5;
}
#app.merch .see-more:hover {
  background-color: #fb556b;
}
</style>
